export enum CurrencyE {
  USD = 'USD',
}
